// Frans (fr-FR), kaartApp: zelfde vorm als kaartApp.nl.ts (golf 3-integratie). De stappen voor
// Google, Outlook en de iPhone noemen de knoppen zoals die apps ze in het Frans tonen.
export const appPlacesFr = {
    placeholder: 'Tape un lieu, comme Piscine De Vliet',
    hintSearch: 'Tape au moins 3 lettres : tu reçois des suggestions de Google Maps.',
    searching: 'Recherche...',
    suggestions: 'Suggestions',
    noResults: 'Rien trouvé. Tu peux aussi simplement taper le lieu.',
    attribution: 'Suggestions de Google Maps',
    chosen: 'Lieu choisi',
    change: 'Autre lieu',
    remove: 'Retirer le lieu',
    typedOnly: 'Texte seulement (pas de lieu sur la carte)',
    notConfigured: 'La recherche via Google Maps n’est pas encore activée sur ce serveur. Tape simplement le lieu.',
    unavailable: 'Google Maps ne répond pas pour l’instant. Tape simplement le lieu, ou réessaie dans un moment.',
    tooMany: 'Un peu trop de recherches. Réessaie dans {minutes} minutes.',
    saveFailed: 'Le lieu n’a pas été enregistré (l’événement, si). Réessaie dans un moment.',
    travelTitle: 'Temps de trajet',
    travelAuto: '{minutes} min {mode}',
    travelAutoHint: 'Calculé depuis chez vous. Si tu choisis toi-même un temps de trajet ci-dessous, c’est lui qui compte.',
    travelPending: 'Calculé à l’enregistrement.',
    travelStatus: {
        no_origin: 'Choisis d’abord le lieu de votre famille, puis l’appli calcule le temps de trajet.',
        no_route: 'Google Maps ne connaît pas d’itinéraire vers ce lieu.',
        not_configured: 'Le calcul du temps de trajet n’est pas encore activé sur ce serveur.',
        unavailable: 'Le temps de trajet n’a pas pu être calculé. Nous réessaierons au prochain enregistrement.',
        module_off: 'Le temps de trajet est désactivé (Réglages · Modules).',
    },
    modeTitle: 'Comment y allez-vous ?',
    modeUsual: 'Comme d’habitude',
    modes: { drive: 'Voiture', bicycle: 'Vélo', walk: 'À pied' },
    modeWith: { drive: 'en voiture', bicycle: 'à vélo', walk: 'à pied' },
    autoOption: 'Automatique ({minutes} min)',
    // fix/afspraakformulier: schakelaar bij "Waar" (onthouden op dit apparaat, per gebruiker).
    google: 'Chercher avec Google Maps',
    googleOn: 'Activé : suggestions via notre serveur (Google Maps).',
    googleOff: 'Désactivé : tu tapes le lieu toi-même. Rien ne part chez Google.',
    moduleOff: 'La recherche de lieux est désactivée (Réglages · Modules). Tape simplement le lieu.',
};
export const appTravelFr = {
    title: 'Temps de trajet et lieux',
    intro: 'Choisis un lieu parmi les suggestions dans « Où », et l’appli calcule combien de temps vous serez en route. La tablette vous dit alors à temps qu’il faut partir.',
    modeTitle: 'Nous nous déplaçons surtout ainsi',
    modeHint: 'Pour chaque événement, tu peux choisir autre chose.',
    saved: 'Enregistré',
    originMissing: 'Votre lieu manque encore. Sans point de départ, pas de temps de trajet.',
    originLink: 'Choisir le lieu',
    googleOff: 'Google Maps n’est pas encore activé sur ce serveur : les suggestions et le temps de trajet ne marchent pas. Taper dans « Où » marche toujours.',
    privacyTitle: 'Qu’est-ce qui part chez Google ?',
    privacyBody: 'Seulement ce que tu tapes dans « Où », une position approximative autour de votre commune (environ 5 km) et, pour le temps de trajet, le point de départ à environ un kilomètre près. Jamais de noms, d’adresses e-mail ni qui vient avec vous. Google calcule pour nous ; la tablette et ton navigateur ne parlent jamais à Google.',
    settingsBody: 'Voiture, vélo ou à pied ; ce qui part chez Google',
};
export const appFeedsFr = {
    title: 'Relier un agenda',
    settingsBody: 'Vos événements aussi dans Google, Outlook ou sur l’iPhone',
    intro: 'Mets aussi vos événements dans Google Agenda, Outlook ou sur ton iPhone. Le tableau reste l’endroit où tu planifies : ce que tu changes là-bas ne revient pas ici.',
    oneWay: 'Dans un seul sens',
    inbound: 'Dans l’autre sens, importer l’agenda de l’école ou du sport ? Ça se fait dans Calendriers.',
    inboundLink: 'Vers Calendriers',
    forWho: 'Pour qui',
    lastFetchedNever: 'jamais',
    settingsLabel: 'Réglages de ce lien',
    newTitle: 'Nouveau lien',
    whose: 'Quels événements ?',
    whole: 'Toute la famille',
    memberOnly: 'Seulement {name}',
    busyOnly: 'Afficher seulement « occupé »',
    busyOnlyHint: 'Les autres voient qu’il y a quelque chose, pas quoi. Pratique pour un agenda de travail.',
    faith: 'Aussi les événements liés à notre foi (comme la Prière ou le cours à la mosquée)',
    faithHint: 'Désactivé par défaut : Google, Microsoft ou Apple les lisent alors aussi.',
    create: 'Créer le lien',
    creating: 'Un instant...',
    created: 'Ton lien est prêt',
    copy: 'Copier le lien',
    copied: 'Copié',
    copyFailed: 'La copie n’a pas marché. Sélectionne le lien et copie-le toi-même.',
    openApple: 'Ouvrir dans Calendrier (iPhone, Mac)',
    linkOnce: 'Colle le lien maintenant dans ton appli d’agenda. Nous ne le gardons pas lisible : plus tard, tu en crées simplement un nouveau.',
    linkLabel: 'Ton lien',
    listTitle: 'Vos liens',
    empty: 'Pas encore de liens. Crée-en un ci-dessus.',
    forWhole: 'Toute la famille',
    forMember: '{name}',
    badgeBusy: 'Occupé seulement',
    badgeFaith: 'Avec la foi',
    lastFetched: 'Dernière récupération : {when}',
    neverFetched: 'Pas encore récupéré par une appli d’agenda',
    hiddenLink: 'Tu ne vois le lien lui-même qu’au moment de le créer.',
    renew: 'Nouveau lien',
    renewTitle: 'Créer un nouveau lien ?',
    renewBody: 'L’ancien lien ne marchera plus ensuite. Colle à nouveau le nouveau lien dans ton appli d’agenda.',
    renewConfirm: 'Créer un nouveau lien',
    revoke: 'Révoquer',
    revokeTitle: 'Révoquer le lien ?',
    revokeBody: 'Ce lien cesse aussitôt de marcher. Les événements disparaissent de l’autre agenda à la prochaine actualisation.',
    revokeConfirm: 'Révoquer',
    revoked: 'Lien révoqué',
    cancel: 'Annuler',
    tooMany: '20 liens maximum par famille. Révoque d’abord un ancien lien.',
    howTitle: 'Comment l’ajouter',
    google: {
        title: 'Google Agenda',
        steps: [
            'Ouvre Google Agenda sur un ordinateur (calendar.google.com).',
            'À gauche, à côté de « Autres agendas », clique sur le signe plus.',
            'Choisis « À partir de l’URL ».',
            'Colle le lien et clique sur « Ajouter un agenda ».',
        ],
    },
    outlook: {
        title: 'Outlook et Microsoft 365',
        steps: [
            'Ouvre Outlook sur le web (outlook.office.com ou outlook.live.com).',
            'Va dans Calendrier et choisis « Ajouter un calendrier ».',
            'Choisis « S’abonner à partir du web ».',
            'Colle le lien, donne un nom au calendrier et clique sur « Importer ».',
        ],
    },
    apple: {
        title: 'iPhone et iCloud',
        steps: [
            'Ouvre Réglages sur ton iPhone.',
            'Touche Apps, puis Calendrier, puis Comptes de calendrier, puis « Ajouter un compte ». (Sur un iPhone plus ancien : Calendrier, puis Comptes.)',
            'Touche « Autre », puis « Ajouter un calendrier avec abonnement ».',
            'Colle le lien et touche « Suivant » puis « Enregistrer ».',
        ],
    },
    refreshNote: 'Soyons honnêtes : Google Agenda ne récupère un tel lien que toutes les quelques heures, parfois encore moins souvent. Outlook et l’iPhone le font plus souvent. Un changement n’apparaît donc pas tout de suite partout ; sur le tableau, si.',
    privacyNote: 'Les événements privés ne partent jamais. Qui a le lien peut lire les événements : ne le partage pas, et révoque-le s’il traîne quelque part.',
    icsBusy: 'Occupé',
    /** Een bijzondere dag van meer dagen in de .ics. */
    icsDayOf: '{title} (jour {index} sur {count})',
};
//# sourceMappingURL=kaartApp.fr.js.map